import React, {useRef, useState} from 'react';
import './PatientDocumentsList.scss';
import i18next from 'i18next';
import {toast} from 'react-toastify';
import DynamicList from '../DynamicList/DynamicList';
import {NOTIFY_OPTS} from '../../constants/Notifiers';
import {errorMessageFromServerError} from '../../Helpers/Helpers';

const PatientDocumentsList = ({patient, fetchPatientDocuments, uploadPatientDocument}) => {
  const fileInputRef = useRef();
  const [shouldReload, setShouldReload] = useState(false);
  const [uploading, setUploading] = useState(false);

  const columnsArray = [
    {
      key:'questionnaire_name',
      columnWeight:1,
      columnNameKey:'QUESTIONNAIRE_NAME',
      propertiesArray:['questionnaire_name'],
      valueFormatter:(aValue) => aValue || i18next.t('ADDITIONAL_UPLOAD')
    },
    {
      key:'question_label',
      columnWeight:1,
      columnNameKey:'QUESTION_LABEL',
      propertiesArray:['question_label'],
      valueFormatter:(aValue) => aValue || '—'
    },
    {
      key:'file_name',
      columnWeight:1,
      columnNameKey:'FILE_NAME',
      propertiesArray:['file_name'],
      templateCell:(aDocument) => (
        <a href={aDocument.file_url}
           target="_blank"
           rel="noopener noreferrer"
           className="patient-document-link">
          {aDocument.file_name}
        </a>
      )
    }
  ];

  const uploadDocuments = (aEvent) => {
    const files = Array.from(aEvent.target.files || []);
    aEvent.target.value = '';

    if(files.length === 0 || uploading){
      return;
    }

    setUploading(true);
    Promise.all(files.map((file) => uploadPatientDocument(patient.id, file))).then(() => {
      toast(i18next.t('DOCUMENT_UPLOAD_SUCCESS'), NOTIFY_OPTS.autoCloseFiveSeconds);
    }).catch((error) => {
      toast(i18next.t('DOCUMENT_UPLOAD_FAILURE', {error:errorMessageFromServerError(error)}), NOTIFY_OPTS.autoCloseFiveSeconds);
    }).finally(() => {
      setUploading(false);
      setShouldReload(true);
    });
  };

  return (
    <div className="patient-documents-list-container">
      <DynamicList id="patient-documents-list"
                   didReload={() => setShouldReload(false)}
                   columnsArray={columnsArray}
                   fetchObjects={(aLimit, aOffset, aSearchString) => fetchPatientDocuments(patient.id, aLimit, aOffset, aSearchString)}
                   shouldReload={shouldReload}
                   addButtonClicked={() => !uploading && fileInputRef.current.click()}
                   explanationKey="DOCUMENTS_EXPLANATION"
                   minColumnWidth={180}
                   totalObjectsKey="TOTAL_DOCUMENTS"
                   responseTotalKeysArray={['data', 'total']}
                   responseObjectKeysArray={['data', 'documents']}
      />

      <input ref={fileInputRef}
             className="patient-documents-file-input"
             type="file"
             multiple
             disabled={uploading}
             onChange={uploadDocuments}
      />
    </div>
  );
};

export default PatientDocumentsList;
